import { render, staticRenderFns } from "./card-action.vue?vue&type=template&id=74c2937f&scoped=true"
import script from "./card-action.vue?vue&type=script&lang=js"
export * from "./card-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2937f",
  null
  
)

export default component.exports